import { render, staticRenderFns } from "./deal-create-group.vue?vue&type=template&id=198a8a48"
import script from "./deal-create-group.vue?vue&type=script&lang=js"
export * from "./deal-create-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports